import { render, staticRenderFns } from "./DashBoardNyx.vue?vue&type=template&id=07a3365e&"
import script from "./DashBoardNyx.vue?vue&type=script&lang=js&"
export * from "./DashBoardNyx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports